import { Head } from "@inertiajs/react"
import AdminLayout from "../../../layouts/AdminLayout"
import WordFormView, { WordForm } from "./Form"

type Props = { word: WordForm; topics: { id: number; name: string }[]; errors?: Record<string, string[]> }

export default function EditWord({ word, topics, errors }: Props) {
  return (
    <AdminLayout title="Edit word">
      <Head title="Edit word" />
      <WordFormView word={word} topics={topics} errors={errors} />
    </AdminLayout>
  )
}
